import { render, staticRenderFns } from "./AdminCommands.vue?vue&type=template&id=71dfa5e3&scoped=true&lang=pug&"
import script from "./AdminCommands.vue?vue&type=script&lang=js&"
export * from "./AdminCommands.vue?vue&type=script&lang=js&"
import style0 from "./AdminCommands.vue?vue&type=style&index=0&id=71dfa5e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dfa5e3",
  null
  
)

export default component.exports